<template>
  <div
    class="tw-fixed tw-top-0 tw-left-0 tw-w-full tw-h-full tw-z-50 tw-flex tw-items-center tw-justify-center"
    :class="{
      'tw-block': value,
      'tw-hidden': !value,
    }"
  >
    <div
      class="tw-bg-black tw-top-0 tw-absolute tw-left-0 tw-w-full tw-h-full tw-z-10 tw-opacity-30"
      @click="$emit('close')"
    ></div>
    <div
      v-if="value || keepAlive"
      class="tw-bg-white tw-shadow-shadow-2 tw-rounded-lg tw-p-6 tw-text-sm tw-leading-5 tw-relative tw-max-h-screen tw-overflow-auto"
      :class="[zIndex]"
      :style="{ width: width + 'px' }"
    >
      <slot></slot>
      <div
        v-if="close"
        class="tw-absolute tw-top-1 tw-right-1 tw-text-xl tw-cursor-pointer"
        @click="$emit('close')"
      >
        <IconButton
          class="!tw-p-2 tw-leading-0 tw-w-8 tw-h-8 tw-flex tw-items-center tw-justify-center"
        >
          <img :src="CloseIcon" />
        </IconButton>
      </div>
    </div>
  </div>
</template>
<script>
import IconButton from '@/components/v3/base/IconButton';
import CloseIcon from '@/assets/icons/close-icon.svg';

export default {
  components: {
    IconButton,
  },

  props: {
    width: {
      type: Number,
      default: 300,
    },

    value: {
      type: Boolean,
      default: false,
    },

    close: {
      type: Boolean,
      default: false,
    },

    zIndex: {
      type: String,
      default: 'tw-z-50',
    },

    keepAlive: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      CloseIcon,
    };
  },
};
</script>
